export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

// process.env.REACT_APP_X is only inlined at build time when it appears as a literal,
// static property access — a dynamic process.env[name] helper is NOT recognized and
// never gets inlined into the client bundle, so it silently reads undefined in the
// browser regardless of what's actually configured. Each of these therefore accesses
// its variable directly, statically, rather than sharing one name-parameterized helper.
export function requireI9ApiBase() {
  const value = process.env.REACT_APP_I9_API_BASE_URL;
  if (!value) throw new Error("Missing required environment variable: REACT_APP_I9_API_BASE_URL");
  return value;
}

export function requireAuthApiBase() {
  const value = process.env.REACT_APP_AUTH_API_BASE_URL;
  if (!value) throw new Error("Missing required environment variable: REACT_APP_AUTH_API_BASE_URL");
  return value;
}

export function requireDashboardUrl() {
  const value = process.env.REACT_APP_DASHBOARD_URL;
  if (!value) throw new Error("Missing required environment variable: REACT_APP_DASHBOARD_URL");
  return value;
}
